import { FC } from "react";
import { Table } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { TableColumn } from "../../../common/Table";
import { rankingColumns } from "../../../config/Tables/category";
import { ICategoryGroup } from "../../../helpers/interfaces/ranking";

interface IRankGroupTable {
    groupName: string,
    currentGroup: ICategoryGroup | undefined,
}

const RankGroupTable: FC<IRankGroupTable> = (
    { groupName, currentGroup }
) => {
    const location = useLocation();

    return currentGroup ? <>
        <h3 className='mb-4'>Classifica {groupName}</h3>
        <div className='rank_table'>
            <Table id={"table_group_" + currentGroup.id + "_ranking"} striped bordered hover responsive>
                <thead>
                    <tr>
                        {rankingColumns.map((column: TableColumn<any>, index: number) => {
                            return <th
                                id={`${"table_category_" + currentGroup.id + "_ranking"}_${column.id}`}
                                key={index}
                                data-index={index}
                            >
                                {column.name}
                            </th>
                        })}
                    </tr>
                </thead>
                <tbody>
                    {
                        currentGroup?.classificaGirone && currentGroup?.classificaGirone.length > 0 ? currentGroup?.classificaGirone.map((element: { [key: string]: any }, index: number) => {
                            return <tr key={index}>
                                {
                                    rankingColumns.map((column: TableColumn<any>, index2: number) => {
                                        let columnId = `table_category_${location.pathname.split("/").pop()}_ranking_${column.id}_${index2}`;
                                        let defaultValue = column.default !== undefined ? column.default : "-";
                                        let columnValue = column.data && element[column.data] !== undefined && element[column.data] !== null ? element[column.data] : defaultValue;

                                        return <td
                                            id={columnId}
                                            key={index2}
                                            data-index={index2}
                                        >
                                            {typeof column.render !== 'undefined'
                                                ? column.render(columnValue, index, element)
                                                : String(columnValue)
                                            }
                                        </td>;
                                    })
                                }
                            </tr>
                        }) : <tr>
                            <td colSpan={rankingColumns.length} className="text-center">
                                Nessuna informazione da mostrare in questa tabella
                            </td>
                        </tr>}
                </tbody>
            </Table>
            <div id="tab_rank_caption" className='d-flex flex-wrap fs-7 ms-2'>
                {currentGroup?.coloriDB.map((item, index) => (
                    <div key={index} className='mb-1 me-2 display-6 fs-6'>
                        <i
                            className="fa fa-circle"
                            aria-hidden="true"
                            style={{ color: `#${item.colore}` }}
                        />{" "}
                        = {item.descrizione}
                    </div>
                ))}
            </div>
        </div>
    </> : <></>
}

export default RankGroupTable;